import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const NotaryService = () => {
    return <ServicesEditTemplate doc="notary_public" service="Notary Public" />;
};

export default NotaryService;
